import GetCostRequestInterface from '../types/requests/get-cost'
import CostInfoInterface from '../types/models/cost-info'
import {
    HEADERS,
    POST,
    URL_REQUEST_CALLBACK,
    URL_GET_CARGO_TYPES,
    URL_GET_COST,
    URL_GET_PROGRAM_INFO,
} from '../constants'
import {CargoTypes} from '../types/models/cargo-types'
import {ProgramInfo} from '../types/models/program-info'
import RequestCallbackInterface from '../types/requests/request-callback'

const getInitFetch = data => ({
    method: POST,
    headers: HEADERS,
    body: JSON.stringify(data),
})

interface ErrorInterface {
    errors: string[]
}

class Api {
    static async getCost(
        data: GetCostRequestInterface
    ): Promise<ErrorInterface | CostInfoInterface> {
        try {
            const response: Response = await fetch(URL_GET_COST, getInitFetch(data))
            if (response.status !== 200) throw new Error('Ошибка запроса стоимости.')
            return await response.json()
        } catch (e) {
            return {errors: [e.message]}
        }
    }

    static async requestCallback(data: RequestCallbackInterface, calculationUuid: string): Promise<ErrorInterface | any> {
        try {
            const response: Response = await fetch(URL_REQUEST_CALLBACK + calculationUuid, {
                method: 'PUT',
                headers: HEADERS,
                body: JSON.stringify(data),
            })
            if (response.status === 400) {
                const responseData: ErrorInterface = await response.json()
                throw new Error(JSON.stringify(responseData.errors) || 'Ошибка отправки заявки.')
            } else if (response.status !== 200) {
                throw new Error('Ошибка отправки заявки.')
            } else {
                return true
            }
        } catch (e) {
            return false
        }
    }

    static async getProgramInfo(): Promise<ErrorInterface | ProgramInfo> {
        try {
            const response: Response = await fetch(URL_GET_PROGRAM_INFO)
            if (response.status !== 200) return {errors: ['Ошибка загрузки информации об опциях.']}
            return await response.json()
        } catch (e) {
            return {errors: [e.message]}
        }
    }

    static async getCargoTypes(): Promise<ErrorInterface | CargoTypes> {
        try {
            const response: Response = await fetch(URL_GET_CARGO_TYPES)
            if (response.status !== 200) return {errors: ['Ошибка загрузки списка грузов.']}
            return await response.json()
        } catch (e) {
            return {errors: [e.message]}
        }
    }
}

export default Api
